import {reactive} from "vue";
import i18n from "../../i18n/i18n";
import { urlsHtml } from "../../../static/docs/brands/corvina";
//@ts-ignore
export default reactive({
  actionHelp: {} as Record<string, string>,
  async fetchHelpData(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    console.log("Fetching help data for language:", lang);

    try {
      this.actionHelp[lang] = await urlsHtml(lang);
    } catch (error) {
      console.warn("No help data found for language:", lang, error);
      this.actionHelp[lang] = await urlsHtml("en"); // Fallback to English if fetch fails
    }
  },
  getLocaleUrlHelp(locale?: string) {
    locale = locale || i18n.global.locale.value;
    const lang = tryGetLangFromLocale(locale);
    return this.actionHelp[lang] || "No help available";
  },
});

function tryGetLangFromLocale(locale: string): string {
  if (locale.length === 2) return locale.toLowerCase();
  return locale?.split('-')?.[0]?.toLowerCase() || "en";
}